import { useTranslation } from "react-i18next";
import { hasPublicLegacyCookie } from "./mode";

/**
 * "Show me the old version" on the public pages: the small way back at the foot of TODAY's public pages, shown only in a browser
 * that opened the secret old-pages link (cookie cy_legacy). Part of the page flow, never floating (on a phone a banner covered buttons).
 */
export const LegacyWayBack = () => {
  const { t } = useTranslation();
  if (!hasPublicLegacyCookie()) return null;
  return (
    <p style={{ position: "relative", zIndex: 1, margin: 0, padding: "4px 16px 16px", textAlign: "center", fontSize: 14 }}>
      {/* A white chip: readable over the old home's picture too. */}
      <a id="cy-legacy-off" href="/?legacy=off" style={{ display: "inline-block", minHeight: 48, lineHeight: "48px", padding: "0 16px", borderRadius: 24, background: "#fff", color: "#0b4a8b", textDecoration: "underline", boxShadow: "0 1px 3px rgba(0,0,0,.2)" }}>
        {t("landing_nav.legacy_off")}
      </a>
    </p>
  );
};
